// extracted by mini-css-extract-plugin
export default {"Modal":"CreateRevisionConfirmModal_Modal__zAiHz","Content":"CreateRevisionConfirmModal_Content__huQ7M","Options":"CreateRevisionConfirmModal_Options__vbJFy"};